import React from 'react';
import { Stack } from '@mui/material';
import { SelectField } from 'components/form';
import { FieldValues, Path, Control } from 'react-hook-form';
import { booleanOptions } from '../constants';

interface Props<FormValues extends FieldValues = FieldValues> {
  namePrefix: Path<FormValues>;
  control: Control<FormValues>;
}

export const BooleanFieldsByRule = <FormValues extends FieldValues = FieldValues>({
  namePrefix,
  control,
}: Props<FormValues>) => {
  return (
    <Stack direction="row" gap="0.5rem" width="100%">
      <SelectField
        label="Select"
        control={control}
        variant="outlined"
        options={booleanOptions}
        name={`${namePrefix}.boolean.value` as Path<FormValues>}
      />
    </Stack>
  );
};
